import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Box, Typography, Grid, Button } from "@mui/material";
import SummaryIcon1 from "../../../static/img/icons/png/summary-icon-1.png";
import SummaryElipse from "../../../static/img/summary-elipse.png";
import { InfoCircle, User } from "iconsax-react";
import Header from "../Components/header";
import FooterComponent from "../../../components/global/Footer";
import { withTranslation } from "react-i18next";
const { URL_PREFIX } = window;


class VF2Step4 extends React.Component {
  constructor() {
    super();
    this.state = {};
  }

  componentWillMount() { }

  render() {
    const { guestDetail, agentDetail } = this.props.vf2;

    return (
      <>
        <div style={{ margin: "30px" }}>
          <Header 
            title={this.props.t("Finish")} 
            selectedGuest={guestDetail}
            subtitle={this.props.t("Essential Information has been submitted to Wakatobi")} 
            agent={agentDetail}
          />
          
          <div style={{ display: "flex", justifyContent: "center" }}>
            <Box
              sx={{
                marginTop: "20px",
                padding: "32px 48px 48px",
                border: "1px solid #EAECF0",
                boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.06)",
                borderRadius: "8px",
                width: "100%",
                height: "100%",
                backgroundColor: "#F9FAFB",
                backgroundImage: `url(${SummaryElipse})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "right",
              }}>
              <img src={SummaryIcon1} />
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "24px",
                  color: "#101828",
                  marginTop: "15px",
                }}>
                {this.props.t("Thank you for filling your information!")}
              </Typography>
              <Typography
                sx={{
                  fontWeight: 300,
                  fontSize: "16px",
                  color: "#475467",
                  marginTop: "10px",
                }}>
                {this.props.t("We’re excited to have you with us soon, if you need anything else from <br/> us be sure to contact us.").split('<br/>')
                  .map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      <br />
                    </React.Fragment>
                  ))}
              </Typography>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  marginTop: "20px",
                }}>
                <Button
                  sx={{
                    padding: "12px 20px",
                    height: "44px",
                    border: "1px solid #D0D5DD",
                    boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                    borderRadius: "8px",
                    color: "#344054",
                  }}>
                  <InfoCircle style={{ marginRight: "10px" }} />
                  <Typography sx={{ fontWeight: 800, fontSize: "14px", textTransform: 'none',  }}>
                    {this.props.t('Need help?')}
                  </Typography>
                </Button>
                {/* <a
                  href={`${URL_PREFIX}/vf2/logout`}
                >
                  <Button
                    sx={{
                      padding: "12px 20px",
                      height: "44px",
                      border: "1px solid #D0D5DD",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                      borderRadius: "8px",
                      color: "#344054",
                      marginLeft: "20px",
                    }}>
                    <LogoutCurve style={{ marginRight: "10px" }} />
                    <Typography sx={{ fontWeight: 800, fontSize: "14px", textTransform: 'none', }}>
                      Exit
                    </Typography>
                  </Button>
                </a> */}
                <a
                  href={`${URL_PREFIX}/vf2/wizard`}
                  style={{ textDecoration: "none" }}>
                  <Button
                    sx={{
                      padding: "12px 20px",
                      height: "44px",
                      border: "1px solid #D0D5DD",
                      boxShadow: "0px 1px 2px rgba(16, 24, 40, 0.05)",
                      borderRadius: "8px",
                      color: "white",
                      background: "#2F37B5",
                      marginLeft: "20px",
                      ":hover": {
                        border: "1px solid #D0D5DD",
                        color: "white",
                        background: "#2F37B5",
                      },
                    }}>
                    <User style={{ marginRight: "10px" }} />

                    <Typography
                      sx={{
                        fontSize: "14px",
                        color: "#FFFFFF",
                        textTransform: 'none',
                      }}>
                      {this.props.t("Guest List")}
                    </Typography>
                  </Button>
                </a>
              </Box>
            </Box>
          </div>

          <FooterComponent />
        </div>
      </>
    );
  }
}

VF2Step4.propTypes = {
  vf2: PropTypes.object.isRequired,
};

const mapDispatchToProps = (dispatch) => bindActionCreators({}, dispatch);

const mapStateToProps = (state) => ({
  vf2: state.vf2,
});

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(VF2Step4));
